import columns from 'utils/columns/metadatas';
import { initialStateFactory, reducerFactory, sagasFactory } from 'utils/factories';

import actionsFactory from 'utils/factories/actions';
import { METADATA } from './actionTypes';

// actions
const actions = actionsFactory(METADATA);
export { actions };

// reducer
const initialState = initialStateFactory(columns);
const reducer = reducerFactory(METADATA);
export default (state = initialState, action) => reducer(state, action);

// sagas
const sagas = sagasFactory(METADATA, '/metadata');
export { sagas };
